/**
 * mergeProviders
 *
 * this routine handles the heavy lifting for
 * merging specified Providers into one Provider
 *
 **/
import React from 'react';
export const mergeProviders = (...components) => {
  return components.reduce((AccumulatedComponents, CurrentComponent) => {
    return ({
      children
    }) => {
      return /*#__PURE__*/React.createElement(AccumulatedComponents, null, /*#__PURE__*/React.createElement(CurrentComponent, null, children));
    };
  }, ({
    children
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, children));
};
//# sourceMappingURL=mergeContextProviders.js.map